import { STORAGE_KEYS } from '@/constants/app'
import { syncChromeThemeColor } from '@/utils/theme-color'

const SPLASH_ID = 'app-splash'
const READY_CLASS = 'app-ready'

let dismissed = false

const MARKUP = `
  <div class="app-splash-grid" aria-hidden="true"></div>
  <div class="app-splash-glow" aria-hidden="true"></div>
  <div class="app-splash-inner">
    <div class="app-splash-mark" aria-hidden="true">MP</div>
    <p class="app-splash-title">MP Plastic Industries</p>
    <p class="app-splash-sub">Enterprise platform</p>
    <div class="app-splash-track" aria-hidden="true"><span class="app-splash-bar"></span></div>
  </div>
  <p class="app-splash-foot">PMMS</p>
`

function hasBootedThisSession(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEYS.BOOT_SPLASH) === '1'
  } catch {
    return false
  }
}

function markBootedThisSession() {
  try {
    sessionStorage.setItem(STORAGE_KEYS.BOOT_SPLASH, '1')
  } catch {
    // Private browsing / blocked storage
  }
}

function revealApp() {
  document.documentElement.classList.add(READY_CLASS)
  syncChromeThemeColor()
}

function skipSplash() {
  dismissed = true
  document.documentElement.classList.add(READY_CLASS, 'splash-skip')
  syncChromeThemeColor()
  removeSplashNode()
}

function removeSplashNode() {
  document.getElementById(SPLASH_ID)?.remove()
}

/** Cover the screen before React paints — first open of the session only. */
export function ensureBootSplash() {
  if (dismissed) return

  if (hasBootedThisSession()) {
    skipSplash()
    return
  }

  let el = document.getElementById(SPLASH_ID)
  if (!el) {
    el = document.createElement('div')
    el.id = SPLASH_ID
    el.setAttribute('role', 'status')
    el.setAttribute('aria-live', 'polite')
    el.setAttribute('aria-busy', 'true')
    el.setAttribute('aria-label', 'Loading MP Plastic Industries')
    el.innerHTML = MARKUP
    document.body.insertBefore(el, document.body.firstChild)
  }

  el.classList.remove('app-splash--out')
  delete el.dataset.dismissed
}

export function dismissBootSplash() {
  if (dismissed) {
    revealApp()
    return
  }
  dismissed = true
  markBootedThisSession()
  revealApp()

  const el = document.getElementById(SPLASH_ID)
  if (!el) return
  if (el.dataset.dismissed === 'true') {
    el.remove()
    return
  }
  el.dataset.dismissed = 'true'

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduce) {
    el.remove()
    return
  }
  el.classList.add('app-splash--out')
  window.setTimeout(() => el.remove(), 320)
}

ensureBootSplash()
